/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeShowcasePhoto
 */
export interface ChallengeShowcasePhoto {
    /**
     * 
     * @type {string}
     * @memberof ChallengeShowcasePhoto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeShowcasePhoto
     */
    imageUrl: string;
    /**
     * Location/point-of-interest chip (e.g. "Avalon · Colosseum").
     * @type {string}
     * @memberof ChallengeShowcasePhoto
     */
    poiTag?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeShowcasePhoto
     */
    objectiveName: string;
    /**
     * Public display name of the submitter.
     * @type {string}
     * @memberof ChallengeShowcasePhoto
     */
    nickname?: string;
}

/**
 * Check if a given object implements the ChallengeShowcasePhoto interface.
 */
export function instanceOfChallengeShowcasePhoto(value: object): value is ChallengeShowcasePhoto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('objectiveName' in value) || value['objectiveName'] === undefined) return false;
    return true;
}

export function ChallengeShowcasePhotoFromJSON(json: any): ChallengeShowcasePhoto {
    return ChallengeShowcasePhotoFromJSONTyped(json, false);
}

export function ChallengeShowcasePhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeShowcasePhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'imageUrl': json['imageUrl'],
        'poiTag': json['poiTag'] == null ? undefined : json['poiTag'],
        'objectiveName': json['objectiveName'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
    };
}

export function ChallengeShowcasePhotoToJSON(json: any): ChallengeShowcasePhoto {
    return ChallengeShowcasePhotoToJSONTyped(json, false);
}

export function ChallengeShowcasePhotoToJSONTyped(value?: ChallengeShowcasePhoto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'imageUrl': value['imageUrl'],
        'poiTag': value['poiTag'],
        'objectiveName': value['objectiveName'],
        'nickname': value['nickname'],
    };
}

